import React, { useState, useEffect, useMemo, useCallback, memo } from "react";
import { Button, Card, Box, Container, Typography, Link, Chip, Avatar } from "@material-ui/core";
import ParkService from "./Locality/Service/parkService";
import { Grid, TextField } from "@material-ui/core";
import CardContent from '@material-ui/core/CardContent';
import { useFormik } from 'formik';
import AdvertisementBanner from "../../components/AdvertisementBanner/AdvertisementBanner"
import GoogleAd from "./GoogleAd";
import RemoveIcon from '@material-ui/icons/RemoveCircleOutlineRounded';
import AddIcon from '@material-ui/icons/AddCircleOutlineRounded';
import { useParams } from "react-router-dom";
import TicketBookingService from "./Locality/Service/ticketBookingService";
import CardHeader from '@material-ui/core/CardHeader';
import { makeStyles } from '@material-ui/core/styles';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import PaymentIcon from '@material-ui/icons/Payment';
import Footer from "../../pages/home/Footer"
import Loader from './Loader';
import SRI from '../home/images/SRI.jpg';
import CouponService from "./Locality/Service/couponService";
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 20,
    color: 'rgb(255, 107, 129)',
    fontWeight: 'bold'
  },
  pos: {
    marginBottom: 12,
  },

});

export default function TicketBooking(props) {
  const classes = useStyles();
  const [mid, setMid] = useState(null);
    const [advtDetails, setAdvtDetails] = useState([]);

  
  const [loading, setLoading] = useState(false);
  const [ticketBooking, setTicketBooking] = useState({
    parkName: '',
    payment:'',
    status:false
  });
  const { parkId } = useParams();
  const [mobile, setMobile] = useState('');
  const [ticketBookingList, setTicketBookingList] = useState([]);
  const [profileRegistrationId, setProfileRegistrationId] = useState('');
  var [error, setError] = useState(null);
  const [fee, setFee] = useState([]);
  
  // New state for additional features
  const [couponCode, setCouponCode] = useState('');
  const [couponApplied, setCouponApplied] = useState(null);
  const [couponError, setCouponError] = useState('');
  const [couponApplying, setCouponApplying] = useState(false);
  const [couponCalculation, setCouponCalculation] = useState(null);
  const [selectedDate, setSelectedDate] = useState('');
  const [availableDates, setAvailableDates] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  
  // Memoize expensive calculations
  const totalSum = useMemo(() => {
    return fee.reduce((sum, item) => sum + item.price * item.quantity, 0);
  }, [fee]);

  // Memoize booked details
  const bookedDetails = useMemo(() => {
    return fee.filter(feeDetails => feeDetails.quantity > 0);
  }, [fee]);

  // Memoize sorted fee array by order
  const sortedFee = useMemo(() => {
    return [...fee].sort((a, b) => (a.order || 999) - (b.order || 999));
  }, [fee]);

  // Responsive hook - optimized with debounce
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 600);
    };
    
    checkMobile();
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkMobile, 150);
    };
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, []);
  
  // Footer navigation handlers - memoized with useCallback
  const handleOpen = useCallback(() => {
    props.history.push('/sriqr/login');
  }, [props.history]);

  const handleChange = useCallback(() => {
    props.history.push('/sriqr/profileregistration');
  }, [props.history]);

  const handleUser = useCallback(() => {
    props.history.push('/sriqr/inspectorlogin');
  }, [props.history]);

  const handleTermsConditions = useCallback(() => {
    props.history.push('/sriqr/termsconditions');
  }, [props.history]);

  const handleRefundPolicy = useCallback(() => {
    props.history.push('/sriqr/refundpolicy');
  }, [props.history]);

  const handlePrivacyPolicy = useCallback(() => {
    props.history.push('/sriqr/privacypolicy');
  }, [props.history]);

  const handleIncrement = useCallback((id, name) => {
    if(name.name === 'Family')
    {
      if(name.quantity>=1){
        alert("Only one Family ticket can be purchased per transaction.")
        return;
      }
    }
    if(name.name === 'Family Addon'){
      setFee((prevItems) => {
        const familyItem = prevItems.find(item => item.name === "Family");
        if(!familyItem || familyItem.quantity < 1){
          alert("Family Addon is an additional item. Please add a Family ticket before selecting the Addon.")
          return prevItems;
        }
        return prevItems.map((item) =>
          item.id === id ? { ...item, quantity: item.quantity + 1, totalprice: (item.price * (item.quantity + 1)) } : item
        );
      });
      return;
    }
    setFee((prevItems) => {
      return prevItems.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1, totalprice: (item.price * (item.quantity + 1)) } : item
      );
    });
  }, []);

  const handleDecrement = useCallback((id, item) => {
    setFee((prevItems) => {
      const updatedItems = prevItems.map(currentItem => {
        if (currentItem.id === id && currentItem.quantity > 0) {
          return { ...currentItem, quantity: currentItem.quantity - 1, totalprice: (currentItem.price * (currentItem.quantity - 1)) };
        }
        return currentItem;
      });

      // Handle Family Addon reset if Family quantity becomes 0
      if (item.name === 'Family') {
        const familyItem = updatedItems.find(i => i.id === id);
        if (familyItem && familyItem.quantity <= 1) {
          return updatedItems.map(currentItem =>
            currentItem.name === "Family Addon"
              ? { ...currentItem, quantity: 0 }
              : currentItem
          );
        }
      }
      return updatedItems;
    });
  }, []);
  // useEffect(() => {
  //     const script = document.createElement('script');
  //     script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2277440900291589";
  //     script.async = true;
  //     script.crossOrigin = "anonymous";
  //     document.body.appendChild(script);
  //     return () => {
  //       document.body.removeChild(script);
       
  //     };
  //   }, []);


  // Memoize getDay function
  const getDay = useCallback(() => {
    const currentDate = new Date();
    const currentDayNumber = currentDate.getDay();
    const daysOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    return daysOfWeek[currentDayNumber];
  }, []);

  const handleOpens = useCallback(() => {
    props.history.push(`/getqr/${parkId}`)
  }, [props.history, parkId]);

  // Memoized Item component
  const Item = memo(({ name, price, quantity, onIncrement, onDecrement }) => {
    const totalPrice = useMemo(() => price * quantity, [price, quantity]);
    
    return (
      <>
        <Grid item xs={4}>
          <div>
            <h4 style={{
              overflow: 'hidden',
              textTransform: 'uppercase',
              textOverflow: 'ellipsis',
              whiteSpace: 'break-spaces'
            }}>{name}</h4>
          </div>
          <div>
            <span> &#x20b9;{price}</span>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div style={{ textAlign: 'center' }}>
            <RemoveIcon style={{ cursor: 'pointer', width: "22px", height: "22px" }} onClick={onDecrement} />
            <span style={{ fontSize: '25px', padding: '5px' }}>{quantity}</span>
            <AddIcon style={{ cursor: 'pointer', width: "22px", height: "22px" }} onClick={onIncrement} />
          </div>
        </Grid>
        <Grid item xs={4}>
          <div style={{ textAlign: 'end' }}>
            <h4> &#x20b9;{totalPrice}</h4>
          </div>
        </Grid>
      </>
    );
  });
  // Optimize API calls - run in parallel
  const getAdvByIdList = useCallback(() => {
    const hardcodedData = {
      parkId: parkId,
      where: "Booking Page"
    };
    ParkService.getAdvbyById(hardcodedData).then((res) => {
      if (res && res.advatagement) {
        setAdvtDetails(res.advatagement);
      }
    }).catch((err) => {
      // Silently handle error
    });
  }, [parkId]);

  // Optimize getByIdList - use useCallback and optimize data processing
  // Moved before useEffect to avoid initialization error
  const getByIdList = useCallback(() => {
    setLoading(true);
    ParkService.getParkById(parkId).then((res) => {
      const park = [];
      if (!res) {
        setLoading(false);
        return;
      }

      setProfileRegistrationId(res.profileRegistrationId || '');

      // Optimize: Use configuration array instead of multiple if-else
      // Order: Lower numbers appear first in UI
      const ticketConfig = [
        { key: "adult", feeKey: "adultFee", name: "adult", isShow: true, order: 1 },
        { key: "child", feeKey: "childFee", name: "child", isShow: true, order: 2 },
        { key: "ticket", feeKey: "ticketFee", name: "ticket", isShow: true, order: 3 },
        { key: "vipadult", feeKey: "vipadultFee", name: "VIP Adult", isShow: true, order: 4 },
        { key: "vipkid", feeKey: "vipkidFee", name: "VIP Kid", isShow: true, order: 5 },
        { key: "gaadult", feeKey: "gaadultFee", name: "GA Adult", isShow: true, order: 6 },
        { key: "gakid", feeKey: "gakidFee", name: "GA Kid", isShow: true, order: 7 },
        { key: "seniorCitizen", feeKey: "seniorCitizenFee", name: "Senior Citizen", isShow: true, order: 8 },
        { key: "women", feeKey: "womenFee", name: "Women", isShow: true, order: 9 },
        { key: "physicallyChallenged", feeKey: "physicallyChallengedFee", name: "Physically Challenged", isShow: true, order: 10 },
        { key: "family", feeKey: "familyFee", name: "Family", isShow: true, order: 11 },
        { key: "familyAddon", feeKey: "familyAddonFee", name: "Family Addon", isShow: false, order: 12 },
        { key: "walker", feeKey: "walkerFee", name: "walker", isShow: true, order: 13 },
        { key: "camera", feeKey: "cameraFee", name: "Camera", isShow: true, order: 14 },
        { key: "photography", feeKey: "photographyFee", name: "Photography", isShow: true, order: 15 },
        { key: "shooting", feeKey: "shootingFee", name: "shooting", isShow: true, order: 16 },
        { key: "twowheeler", feeKey: "twowheelerFee", name: "Two Wheeler", isShow: true, order: 17 },
        { key: "fourwheeler", feeKey: "fourwheelerFee", name: "Four Wheeler", isShow: true, order: 18 }
      ];

      // Use forEach instead of map for side effects - more performant
      ticketConfig.forEach(({ key, feeKey, name, isShow, order }) => {
        if (res[key] && res[feeKey]) {
          park.push({
            id: getRandomInt(1000, 10000),
            price: Number(res[feeKey]),
            quantity: 0,
            name: name,
            isShow: isShow,
            order: order
          });
        }
      });

      // Sort by order before setting state
      park.sort((a, b) => (a.order || 999) - (b.order || 999));

      // If only "ticket" option is enabled (no other ticket types), set quantity to 1 by default
      const ticketItem = park.find(item => item.name === "ticket");
      const otherTicketTypes = park.filter(item => 
        item.name !== "ticket" && 
        item.name !== "Two Wheeler" && 
        item.name !== "Four Wheeler" && 
        item.name !== "Camera" && 
        item.name !== "Photography" && 
        item.name !== "shooting" && 
        item.name !== "walker"
      );
      
      // If ticket exists and no other ticket types (adult, child, VIP, etc.) are enabled
      if (ticketItem && otherTicketTypes.length === 0) {
        ticketItem.quantity = 1;
        ticketItem.totalprice = ticketItem.price;
      }

      setFee(park);
      setTicketBooking(res);
      
      if(res.payment){
        setMid(res.mid);
      }
      
      // Handle custom booking dates
      if(res.isEnabledCustomBookingDates && res.bookingDates && Array.isArray(res.bookingDates)) {
        setAvailableDates(res.bookingDates);
        // Set first available date as default if none selected
        if(res.bookingDates.length > 0) {
          setSelectedDate(prevDate => prevDate || res.bookingDates[0]);
        }
      }

      setLoading(false);
    }).catch((err) => {
      setError(err.message);
      setLoading(false);
    });
  }, [parkId]); // Removed selectedDate from dependencies to avoid circular dependency

  useEffect(() => {
    // Run API calls in parallel for faster loading
    getByIdList();
    getAdvByIdList();
  }, [parkId, getByIdList, getAdvByIdList]); // Include dependencies
  useEffect(() => {
    // Step 2: Load Paytm script dynamically after MID is fetched
    if (mid) {
      const script = document.createElement("script");
      script.type = "application/javascript";
      script.src = `${process.env.REACT_APP_PAYTM_SCRIPT_SCRIPT}/merchantpgpui/checkoutjs/merchants/${mid}.js`;

      //script.src = `https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/${mid}.js`;
      script.crossOrigin = "anonymous";
     // script.onload = () => onScriptLoad();
      document.body.appendChild(script);

      // Clean up the script when the component unmounts
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [mid]);
 
  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function isDate(val) {
    // Cross realm comptatible
    return Object.prototype.toString.call(val) === '[object Date]'
  }
  function isObj(val) {
    return typeof val === 'object'
  }
  function stringifyValue(val) {
    if (isObj(val) && !isDate(val)) {
      return JSON.stringify(val)
    } else {
      return val
    }
  }
  function buildForm({ action, params }) {
    const form = document.createElement('form')
    form.setAttribute('method', 'post')
    form.setAttribute('action', action)

    Object.keys(params).forEach(key => {
      const input = document.createElement('input')
      input.setAttribute('type', 'hidden')
      input.setAttribute('name', key)
      input.setAttribute('value', stringifyValue(params[key]))
      form.appendChild(input)
    })

    return form
  }
  function post(details) {
    const form = buildForm(details)
 
    document.body.appendChild(form)
    form.submit()
    form.remove()
    //setLoading(false);
  }
  const payment = (values) => {
    TicketBookingService.paymentProcess(values).then((response) => {
      var information = {
        action: process.env.REACT_APP_CCAV_URL,
        params: response
      }

      post(information);

    })
  }
  const paytmPayment = (values) => {
    TicketBookingService.paytmPaymentProcess(values).then((response) => {
      var information = {
        action: process.env.REACT_APP_CCAV_URL,
        params: response
      }
      
      if(response.body.resultInfo.resultStatus === "S"){
        const token = response.body.txnToken;
        postPaytm(token,values);

      }
     // post(information);

    })
  }
  const postPaytm =(token,values)=>{
    var config = {
      "root": "",
      "flow": "DEFAULT",
      "data": {
      "orderId": values.id, /* update order id */
      "token": token, /* update token value */
      "tokenType": "TXN_TOKEN",
      "amount": values.amount /* update amount */
      },
      "handler": {
      "notifyMerchant": function(eventName,data){
      console.log("notifyMerchant handler function called");
      console.log("eventName => ",eventName);
      if(eventName === 'APP_CLOSED'){
        setLoading(false);
      }
    //  console.log("data => ",data);
      }
      }
      };
      if (window.Paytm && window.Paytm.CheckoutJS) {
        window.Paytm.CheckoutJS.init(config).then(() => {
            window.Paytm.CheckoutJS.invoke();
          })
          .catch((error) => console.error("Paytm error:", error));
      }
  }

  // Memoize discount calculations - moved before bookTickets to avoid initialization error
  const getDiscountAmount = useCallback(() => {
    if (couponCalculation && typeof couponCalculation.discountAmount === 'number') {
      return couponCalculation.discountAmount;
    }
    if (!couponApplied) return 0;
    return couponApplied.discountType === 'percentage'
      ? (totalSum * couponApplied.discountValue) / 100
      : couponApplied.discountValue;
  }, [couponCalculation, couponApplied, totalSum]);

  const getFinalAmount = useCallback(() => {
    if (couponCalculation && typeof couponCalculation.finalAmount === 'number') {
      return couponCalculation.finalAmount;
    }
    return Math.max(0, totalSum - getDiscountAmount());
  }, [couponCalculation, totalSum, getDiscountAmount]);

  const bookTickets = useCallback(() => {
    const phoneNumberRegex = /^\d{10}$/;
    const day = getDay();

    if (!mobile) {
      alert("Please enter mobile number");
      return;
    }
    if (!phoneNumberRegex.test(mobile)) {
      alert("Please enter valid mobile number");
      return;
    }
    if (ticketBooking.holidayDays && ticketBooking.holidayDays.includes(day)) {
      alert("You cant procced to book the ticket. today is holiday ");
      return;
    }
    if (bookedDetails.length <= 0) {
      alert("You need to select atleast one field");
      return;
    }
    if(!ticketBooking?.status){
      alert(`This ${ticketBooking?.parkName} is currently inactive. Please contact the support team for assistance.`);
      return;
    }
    if(ticketBooking?.isEnabledCustomBookingDates && availableDates.length > 0 && !selectedDate){
      alert("Please select a booking date to continue.");
      return;
    }

    const finalAmount = couponApplied ? getFinalAmount() : totalSum;
    
    // Extract eventId from park details - handle both object and string/null cases
    let eventIdValue = null;
    if (ticketBooking.eventId) {
      if (typeof ticketBooking.eventId === 'object' && ticketBooking.eventId._id) {
        eventIdValue = ticketBooking.eventId._id;
      } else if (typeof ticketBooking.eventId === 'string') {
        eventIdValue = ticketBooking.eventId;
      }
    }
    
    const ticketDetails = {
      fee: bookedDetails,
      totalAmount: finalAmount,
      originalAmount: totalSum,
      discountAmount: couponApplied ? getDiscountAmount() : 0,
      couponCode: couponApplied ? couponApplied.couponCode : null,
      selectedDate: selectedDate || null,
      createAt: selectedDate,
      parkId: parkId,
      parkName: ticketBooking.parkName,
      mobile: mobile,
      paymentStatus: "pending",
      profileRegistrationId: profileRegistrationId,
      eventId: eventIdValue,
      useragent: navigator.userAgent,
      paymentVendor: ticketBooking.payment
    };
    
    setLoading(true);
    TicketBookingService.creteTicketBooking(ticketDetails).then((res) => {
      setMobile('');
      if(ticketBooking.payment === 'paytm'){
        paytmPayment({ amount: finalAmount, mobile: mobile, id: res.id, mid: ticketBooking.mid, parkId: parkId });
      } else {
        payment({ amount: finalAmount, mobile: mobile, id: res.id, mid: ticketBooking.mid, parkId: parkId });
      }
    })
    .catch((err) => {
      setLoading(false);
      alert(err.response?.data?.message || 'An error occurred');
    });
  }, [mobile, bookedDetails, totalSum, ticketBooking, selectedDate, availableDates, couponApplied, parkId, profileRegistrationId, getDay, getFinalAmount, getDiscountAmount]);

  const updateMobile = useCallback((event) => {
    setMobile(event.target.value);
  }, []);

  // Memoize discount and final amounts
  const discountAmount = useMemo(() => getDiscountAmount(), [getDiscountAmount]);
  const finalAmount = useMemo(() => getFinalAmount(), [getFinalAmount]);

  // Coupon application function
  const handleApplyCoupon = useCallback(async () => {
    if (!ticketBooking?.isEnabledCoupon) return;
    if (!couponCode.trim()) {
      setCouponError('Please enter a coupon code');
      return;
    }

    try {
      setCouponApplying(true);
      setCouponError('');
      const payload = {
        couponCode: couponCode.trim().toUpperCase(),
        profileRegistrationId: profileRegistrationId,
        parkId: parkId,
        orderAmount: String(totalSum)
      };
      const response = await CouponService.validateCoupon(payload);

      if (response && response.coupon && response.calculation) {
        setCouponApplied(response.coupon);
        setCouponCalculation(response.calculation);
        setCouponError('');
      } else {
        setCouponError(response?.message || 'Invalid coupon code');
        setCouponApplied(null);
        setCouponCalculation(null);
      }
    } catch (error) {
      setCouponError('Failed to validate coupon. Please try again.');
      setCouponApplied(null);
      setCouponCalculation(null);
    } finally {
      setCouponApplying(false);
    }
  }, [ticketBooking?.isEnabledCoupon, couponCode, profileRegistrationId, parkId, totalSum]);

  // Remove applied coupon
  const handleRemoveCoupon = useCallback(() => {
    setCouponApplied(null);
    setCouponCode('');
    setCouponError('');
    setCouponCalculation(null);
  }, []);

  // Optimized coupon re-validation with better debouncing
  useEffect(() => {
    if (!couponApplied || totalSum === 0) return;
    
    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        setCouponApplying(true);
        const payload = {
          couponCode: couponApplied.couponCode,
          profileRegistrationId: profileRegistrationId,
          parkId: parkId,
          orderAmount: String(totalSum)
        };
        const response = await CouponService.validateCoupon(payload);
        if (!cancelled && response && response.coupon && response.calculation) {
          setCouponApplied(response.coupon);
          setCouponCalculation(response.calculation);
          setCouponError('');
        }
      } catch (e) {
        if (!cancelled) {
          setCouponError('Failed to refresh coupon calculation.');
        }
      } finally {
        if (!cancelled) setCouponApplying(false);
      }
    }, 500); // Increased debounce for better performance
    
    return () => { 
      cancelled = true; 
      clearTimeout(timer); 
    };
  }, [totalSum, couponApplied, profileRegistrationId, parkId]);

  const formik = useFormik({
    initialValues: ticketBooking,
    enableReinitialize: true,
    // validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      //   SchooleRegistrationService.creteSchooleRegistration(values).then((res) => {

      //     alert(" Registration Successfully.");
      //     props.history.push('/montessori/login');
      //   })
      //     .catch((err) => {
      //       alert(err.response.data.message);
      //     })
    },
  });


  return (
    <>
 {loading ? <Loader />:


      <Box   >
        <Grid container
          spacing={0}
          direction="column"
          alignItems="center"

          style={{ minHeight: '100vh' }}>
               {ticketBooking?.isHomeBannerEnabled && ticketBooking?.homeBannerImage && (
                  <Box style={{ 
                    padding: isMobile ? '0 8px' : '0 16px', 
                    marginBottom: '16px' 
                  }}>
                    <img 
                      src={ticketBooking.homeBannerImage} 
                      alt="Park Banner" 
                        style={{ 
                          width: '100%', 
                          height: isMobile ? '150px' : '400px', 
                          objectFit: 'cover',
                          borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                      }} 
                    />
                  </Box>
                )}
          <form onSubmit={formik.handleSubmit} class="form" style={{ width: '100%', margin: '15px' }} >
            <div >
              <Card >
                <CardHeader
                  avatar={
                    <LocationOnIcon style={{ color: 'rgb(255, 107, 129)', fontSize: 25 }} />
                  }
                  title={
                    <div>
                      {ticketBooking?.company && String(ticketBooking.company).trim() !== '' && (
                        <Typography variant="h6" style={{ color: 'black', fontSize: '14px', marginBottom: '4px', fontWeight: 'bold' }}>
                          {ticketBooking.company}
                        </Typography>
                      )}
                      <Typography variant="h5" style={{ fontWeight: 'bold', color: 'rgb(255, 107, 129)' }}>
                        {ticketBooking?.parkName}
                      </Typography>
                    </div>
                  }
                  classes={{
                    title: classes.title
                  }}
                />
                
                {/* Home Banner Image */}
             
                
                {/* <Grid item xs={12}>
                    <PageTitle title="Ticket Booking" />
                  </Grid> */}
                <CardContent>
                  {(ticketBooking?.isCloakRoom || ticketBooking?.isHolidays || ticketBooking?.holidayDays ) ? <Grid item xs={12}>
                    <h4> Note: <span style={{
                      'color': "#0a88e4",
                      'font-size': "13px"
                    }}>
                      {ticketBooking?.isCloakRoom ? <span>1.Cloak room Avilable</span> : ''},{ticketBooking?.isHolidays ? <span>2.Holidays on {ticketBooking?.holidayDays}</span> : ''}
                      
                    </span></h4>

                  </Grid> : ''}
                  {(ticketBooking?.note && ticketBooking?.note !== "") ? <Grid item xs={12}>
                    <h4> NOTE: <span style={{
                      'color': "#0a88e4",
                      'font-size': "15px",
                      'margin-bottom':'10px',
                      'text-transform':'uppercase',
                      
                    }}>
                      {ticketBooking?.note }
                      
                    </span></h4>

                  </Grid> : ''}

                  <Grid item xs={12} >
                    {/* <TextField

                      margin="dense"
                      id="parkName"
                      name="parkName"
                      value={ticketBooking.parkName}
                      // label=" Name of the entity"
                      label={<span style={{ fontWeight: '600' }}>Name of the entity</span>}

                      type="text"
                      variant="outlined"
                      style={{ width: '100%' }}
                      
                    /> */}
                    {/* <span style="color:blue">blue</span> */}
                    {/* <span style={{fontWeight:"600", fontSize:"x-large", color:'purple'}}>
                    {ticketBooking?.parkName}
                    </span> */}
                  </Grid>
                  
                  <Grid item xs={12}>
                    <TextField autoFocus
                      style={{ width: '100%' }}
                      margin="dense"
                      id="mobile"
                      name="mobile"
                      value={mobile}
                      onChange={updateMobile}
                      label="Enter Mobile Number"
                      type="text"
                      variant="outlined"

                    />
                  </Grid>
                  
                  {/* Custom Booking Dates Selector */}
                  {ticketBooking?.isEnabledCustomBookingDates && availableDates.length > 0 && (
                    <Grid item xs={12} style={{ marginTop: '16px' }}>
                      <Typography variant="h6" style={{ 
                        color: 'rgb(255, 107, 129)', 
                        fontWeight: 'bold',
                        marginBottom: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: isMobile ? '16px' : '20px',
                        justifyContent: isMobile ? 'center' : 'flex-start'
                      }}>
                        <CalendarTodayIcon style={{ fontSize: isMobile ? '20px' : '24px' }} />
                        {/* Select Booking Date */}
                        Choose your visit date
                      </Typography>
                      <Box style={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: '8px',
                        justifyContent: isMobile ? 'center' : 'flex-start'
                      }}>
                        {availableDates.map((date, index) => {
                          const isSelected = selectedDate === date;
                          // Optimize: Format date once per render
                          const dateObj = new Date(date);
                          const formattedDate = dateObj.toLocaleDateString('en-IN', {
                            weekday: 'short',
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          });
                          
                          return (
                            <Chip
                              key={`date-${date}-${index}`}
                              label={formattedDate}
                              onClick={() => setSelectedDate(date)}
                              style={{
                                backgroundColor: isSelected ? 'rgb(255, 107, 129)' : '#f5f5f5',
                                color: isSelected ? 'white' : '#333',
                                cursor: 'pointer',
                                border: isSelected ? 'none' : '1px solid #ddd',
                                fontWeight: isSelected ? 'bold' : 'normal',
                                fontSize: isMobile ? '12px' : '14px',
                                height: isMobile ? '32px' : '36px'
                              }}
                              avatar={isSelected ? <CheckCircleIcon style={{ color: 'white', fontSize: '16px' }} /> : null}
                            />
                          );
                        })}
                      </Box>
                      {selectedDate && (
                        <Typography variant="body2" style={{ 
                          marginTop: '8px', 
                          color: '#666',
                          fontStyle: 'italic',
                          textAlign: isMobile ? 'center' : 'left',
                          fontSize: isMobile ? '12px' : '14px'
                        }}>
                          Selected: {new Date(selectedDate).toLocaleDateString('en-IN', {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </Typography>
                      )}
                      {selectedDate && (
                        <Typography variant="body2" style={{ 
                          marginTop: '4px', 
                          color: 'rgb(112, 57, 177)',
                          fontWeight: 'bold',
                          textAlign: isMobile ? 'center' : 'left',
                          fontSize: isMobile ? '11px' : '13px'
                        }}>
                          * Ticket valid for that day only
                        </Typography>
                      )}
                    </Grid>
                  )}
                  
                </CardContent>


              </Card>
            </div>
            <div style={{ marginTop: "2%" }}>
              <Card >

                <CardHeader
                  avatar={

                    <ConfirmationNumberIcon style={{ color: 'rgb(255, 107, 129)', fontSize: 25 }} />

                  }
                  classes={{
                    title: classes.title
                  }}
                  title="Number of tickets"

                />
                <CardContent>
                  <Grid container >
                    {sortedFee.map(item => (
                      <Item
                        key={item.id}
                        name={item.name}
                        price={item.price}
                        quantity={item.quantity}
                        onIncrement={() => handleIncrement(item.id, item)}
                        onDecrement={() => handleDecrement(item.id, item)}
                      />
                    ))}
                  </Grid>
                </CardContent>


              </Card>
            </div>
            <div style={{ marginTop: "2%" }}>
              <Card >

                <CardHeader
                  avatar={

                    <PaymentIcon style={{ color: 'rgb(255, 107, 129)', fontSize: 25 }} />

                  }
                  classes={{
                    title: classes.title
                  }}
                  title="Amount to be paid"

                />
                <CardContent>
                  <Grid container spacing={3}>
                  {/* Coupon Section */}
                  {ticketBooking?.isEnabledCoupon && (
                    <Grid item xs={12} style={{ marginBottom: '16px' }}>
                      <Typography variant="h6" style={{ 
                        color: 'rgb(255, 107, 129)', 
                        fontWeight: 'bold',
                        marginBottom: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: isMobile ? '16px' : '20px',
                        justifyContent: isMobile ? 'center' : 'flex-start'
                      }}>
                        <LocalOfferIcon style={{ fontSize: isMobile ? '20px' : '24px' }} />
                        Apply Coupon
                      </Typography>
                      
                      {!couponApplied ? (
                        <Box style={{ 
                          display: 'flex', 
                          gap: '8px', 
                          alignItems: 'center',
                          flexDirection: isMobile ? 'column' : 'row'
                        }}>
                          <TextField
                            size="small"
                            variant="outlined"
                            placeholder="Enter coupon code"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                            style={{ 
                              flex: 1,
                              width: isMobile ? '100%' : 'auto',
                              marginBottom: isMobile ? '8px' : '0'
                            }}
                          />
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleApplyCoupon}
                            disabled={couponApplying}
                            style={{ 
                              backgroundColor: 'rgb(255, 107, 129)',
                              minWidth: isMobile ? '100%' : '100px'
                            }}
                          >
                            {couponApplying ? 'Applying...' : 'Apply'}
                          </Button>
                        </Box>
                      ) : (
                        <Box style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: '12px',
                          padding: '12px',
                          backgroundColor: '#e8f5e8',
                          borderRadius: '8px',
                          border: '1px solid #4caf50',
                          flexDirection: isMobile ? 'column' : 'row'
                        }}>
                          <Box style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '8px',
                            width: isMobile ? '100%' : 'auto'
                          }}>
                            <CheckCircleIcon style={{ color: '#4caf50' }} />
                            <Box style={{ flex: 1 }}>
                              <Typography variant="body1" style={{ fontWeight: 'bold', color: '#2e7d32' }}>
                                {couponApplied.couponName} Applied!
                              </Typography>
                              <Typography variant="body2" style={{ color: '#666' }}>
                                {couponApplied.discountType === 'percentage' 
                                  ? `${couponApplied.discountValue}% off` 
                                  : `₹${couponApplied.discountValue} off`
                                }
                              </Typography>
                            </Box>
                          </Box>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={handleRemoveCoupon}
                            style={{ 
                              color: '#f44336', 
                              borderColor: '#f44336',
                              width: isMobile ? '100%' : 'auto'
                            }}
                          >
                            Remove
                          </Button>
                        </Box>
                      )}
                      
                      {couponError && (
                        <Typography variant="body2" style={{ 
                          color: '#f44336', 
                          marginTop: '8px',
                          fontStyle: 'italic',
                          textAlign: isMobile ? 'center' : 'left',
                          fontSize: isMobile ? '12px' : '14px'
                        }}>
                          {couponError}
                        </Typography>
                      )}
                    </Grid>
                  )}

                  <Grid item xs={6}>
                    <h4> Sub Total:</h4>
                  </Grid>
                  <Grid item xs={6}>
                    <div style={{ textAlign: 'end' }}>
                      <h3>  &#x20b9;  {totalSum}.00</h3>
                    </div>
                  </Grid>
                  
                  {/* Discount Amount */}
                  {couponApplied && (
                    <>
                      <Grid item xs={6}>
                        <h4 style={{ color: '#4caf50' }}> Discount:</h4>
                      </Grid>
                      <Grid item xs={6}>
                        <div style={{ textAlign: 'end' }}>
                          <h3 style={{ color: '#4caf50' }}> -&#x20b9; {discountAmount.toFixed(2)}</h3>
                        </div>
                      </Grid>
                    </>
                  )}

                  {/* Final Total - always show */}
                  <Grid item xs={6}>
                    <h4 style={{ fontWeight: 'bold', color: 'rgb(255, 107, 129)' }}> Grand Total:</h4>
                  </Grid>
                  <Grid item xs={6}>
                    <div style={{ textAlign: 'end' }}>
                      <h3 style={{ fontWeight: 'bold', color: 'rgb(255, 107, 129)' }}> &#x20b9; {(couponApplied ? finalAmount : totalSum).toFixed(2)}</h3>
                    </div>
                  </Grid>
                  </Grid>



                </CardContent>
              </Card>
            </div>
            <div style={{ marginTop: "2%" }}>
              <Grid item xs={12}>
                <div style={{ textAlign: 'left' }}>
                  {/* <a href="javascript:void(0)" class="btn" ><i class="lni lni-apple"></i> Book More Tickets</a> */}
                  {/* <PublicRoute path="/ticketbooking/:parkId" component={TicketBooking} /> */}

                  <a style={{ fontWeight: 'bold', color: 'rgb(112, 57, 177)', fontSize: 'large' }} href="javascript:void(0)" onClick={handleOpens} class="page-scroll active">
                     Get QR </a>
                  <p>(In case QR not generated after payment, click here)</p>
                </div>
              </Grid>
            </div>
            <Grid item xs={12}>
            <div style={{ marginTop: "2%" }}>
             
                <div style={{ textAlign: 'center' }}>
                  <Button style={{ backgroundColor: 'rgb(255, 107, 129)', color: 'white', marginBottom: '20px' }} disabled={!ticketBooking?.status} onClick={bookTickets} variant="contained" >Book</Button>
                </div>
            
            </div>
            </Grid>
          </form>
          
        </Grid>
        <div id="ad-container" style={{ margin: "20px 0" }}>
        {/* <GoogleAd /> */}
      </div>
        {advtDetails.map(({ advatagementName,imgURL,urlLink,desc },index) => (

<AdvertisementBanner key={index}
imageUrl={imgURL.length ? imgURL[0]:''}
heading={advatagementName}
description={desc}
buttonText="Shop Now"
buttonUrl={urlLink}
/>

))}
        {/* Custom Footer */}
        <Box
          sx={{
            background: "rgb(13, 59, 102)",
            color: "white",
            py: 4,
            mt: 4,
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              {/* Logo + Tagline */}
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <img
                   src={SRI}
                    alt="Logo"
                    style={{ width: "85px" }}
                  />
                </Box>
                <Typography variant="body2" sx={{ opacity: 0.8 }} style={{color:'white'}}>
                Making venue access seamless with digital solutions.
                </Typography>
              </Grid>

              {/* Quick Links */}
              <Grid item xs={12} md={4}>
                <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem", }} style={{color:"white"}}>
                  Quick Links
                </Typography>
                <br></br>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Link className="nav-item" >
                    <a href="javascript:void(0)" onClick={handleChange} className="page-scroll active"
                        aria-label="Toggle navigation" style={{color:'white'}}>Profile Registration</a>
                  </Link>
                  <Link className="nav-item">
                    <a href="javascript:void(0)" onClick={handleOpen} className="page-scroll active" style={{color:'white'}}> Client Login</a>
                  </Link>
                  <Link className="nav-item">
                    <a href="javascript:void(0)" onClick={handleUser} className="page-scroll active" style={{color:'white'}}> Ticket Inspector</a>
                  </Link>
                  <Link className="nav-item">
                    <a href="javascript:void(0)" onClick={handleTermsConditions} className="page-scroll active" style={{color:'white'}}> Terms And Conditions</a>
                  </Link>
                  <Link className="nav-item">
                    <a href="javascript:void(0)" onClick={handleRefundPolicy} className="page-scroll active" style={{color:'white'}}> Refund Policy</a>
                  </Link>
                  <Link className="nav-item">
                    <a href="javascript:void(0)" onClick={handlePrivacyPolicy} className="page-scroll active" style={{color:'white'}}> Privacy Policy</a>
                  </Link>
                </Box>
              </Grid>

              {/* Services */}
              <Grid item xs={12} md={4}>
                <Typography variant="h6" sx={{ mb: 2, fontSize: "1rem" }} style={{color:'white'}}>
                  Services
                </Typography>
                <br></br>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }} >
                  <Typography variant="body2" style={{color:'white'}}>
                    Parks
                  </Typography>
                  <Typography variant="body2" style={{color:'white'}}>
                    Doctor
                  </Typography>
                  <Typography variant="body2" style={{color:'white'}}>
                  Bank 
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Box
              sx={{
                borderTop: "1px solid rgba(255, 255, 255, 0.2)",
                mt: 4,
                pt: 2,
                textAlign: "center",
              }}
            >
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                © 2025 sriqr.com All rights reserved. | Developed by{" "}
                <Link
                  href="https://www.srshta.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "inherit",
                    textDecoration: "underline",
                    "&:hover": {
                      color: "#ffd700",
                    },
                  }}
                >
                  Srshta Tech Solution Pvt Ltd
                </Link>
              </Typography>
            </Box>
          </Container>
        </Box>
      </Box>}
     
{/* <Footer link="https://www.ccavenue.com/terms_conditions.jsp#:~:text=Subject%20to%20the%20terms%20of,handling%20fee%2C%20express%20payout%20charges%2C"></Footer> */}
    </>
  );
}


